import { FEATURE_VALUE_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: FEATURE_VALUE_MNG,
  relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '请输入价值名称',
    moreBtnWidth: 160,
    searchFieldNameArr: ['featureValue'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'FeatureValueCreate'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '功能价值',
          prop: 'featureValue'
        }
      },
      {
        props: {
          label: '功能价值说明',
          prop: 'valueDesc'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 180
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime',
          width: 180
        },
        dataType: 'date'
      }
      // },
      // {
      //   //操作
      //   props: {
      //     showBtnNum: '2'
      //   },
      //   dataType: 'operation'
      // }
    ],
    menus: [
      // {
      //   icon: 'el-icon-edit',
      //   label: 'edit',
      //   command: 'FeatureValueEdit',
      //   name: 'edit'
      // }
      // },
      // {
      //   icon: 'el-icon-delete',
      //   label: 'delete',
      //   command: 'IndustryDelete',
      //   name: 'delete',
      //   confirm: {
      //     msg: 'tips.confirm.industryMng.deleteMsg'
      //   }
      // }
    ]
  }
}
